import eventBus from '../../vue-functions/event-bus.js';

function resetSortBy() {
  eventBus.$emit('sort-by-reset');
  this.settings.filters.sortby = '';
  this.settings.currentSortby = '';
}

export default resetSortBy;
